<template>
  <div class="order-operations-moda-map">
    <assets-offline-map
      v-if="localOrder"
      :mode.sync="mode_"
      :map-id="mapId"
      :map-config="mapConfig_"
      :selected="selected"
      :modifiable="!disabled"
      :can-view-summary="false"
      :can-create="!disabled"
      fetch-on="border"
      :local-list="true"
      :fetch-params="mapFetchParams"
      :custom-filter-assets="customFilterAssets"
      :asset-code-chain-ids="assetCodeChainIds"
      :contract-ids="[order.contract_id]"
      :contract-id="order.contract_id"
      :order-type-code-id="localOrder && localOrder.order_type_id ? localOrder.order_type_id : undefined"
      with-unassigned-order-type-codes
      @click-map="onClickMap"
      @select="onSelect"
      @asset-created="onAssetCreated"
      @locationfound="onLocationFound"
      ref="assetsOfflineMap"
    >
      <template #detailHeaderButtons="{ close }">
        <slot name="mapDetailHeaderButtons" :close="close" />
      </template>
      <template #custom="{ mode }">
        <slot name="mapCustomSlot" :mode="mode" />
      </template>
      <!-- <template #localListContentTop>
        <location-autocomplete :config="{ autofocus: true }" style="margin-bottom: 10px" @location="getAddressData"></location-autocomplete>
      </template> -->
    </assets-offline-map>
    <div class="columns" style="margin-top: 5px">
      <div class="column is-9">
        <b-field label>
              <!--
              <div class="control is-clearfix is-expanded">
                  <vue-google-autocomplete
                    id="address-autocomplete"
                    ref="addressAutoComplete"
                    class="input"
                    :country="['nz']"
                    placeholder="Search Address"
                    v-on:placechanged="getAddressData"
                    :address="address"
                  ></vue-google-autocomplete>
              </div>
              -->
              <!-- <div class="control is-clearfix is-expanded">
                <location-autocomplete :config="{ dropdownPosition: 'top' }" @location="getAddressData"></location-autocomplete>
              </div> -->
              <!-- <p class="control">
                <button
                  id="gps_locator"
                  class="button"
                  :disabled="!searchAddress"
                  @click.prevent="goToAddress"
                >
                  Select
                </button>
              </p> -->
        </b-field>
      </div>
    </div>

  </div>
</template>

<script>
import { OrderService } from "@/services/order.service";
import AssetsOfflineMap from "@/components/AssetsOfflineMap";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import VueGoogleAutocomplete from "@/components/partials/VueGoogleAutocomplete";
import LocationAutocomplete from "./LocationAutocomplete";

export default {
  props: {
    order: {
      type: Object
    },
    operation: {
      type: Object
    },
    selected: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      required: false
    },
    height: {
      type: Number,
      default: 600
    },
    mode: {
      type: String,
      default: "list"
    },
    mapId: {
      type: String,
      default: "operation-modal-map"
    },
    address: {},
    mapConfig: {
      type: Object,
      default: () => {}
    },
    filterAssetTypes: {
      type: Array,
      default: () => ([])
    },
  },
  components: {
    AssetsOfflineMap,
    VueGoogleAutocomplete,
    LocationAutocomplete,
  },
  data: () => ({
    localOrder: null,
    mapConfig_: {
      height: 600,
      // hasDrawControl: true,
      // hasDrawToggleControl: true,
      hasLocateControl: false,
      hasOfflineControl: false,
      extendedBounds: 250,
      scrollable: true,
      scrollWheelZoom: false,
      clickable: true
    },
    // searchAddress: null,
    mode_: "list"
  }),
  computed: {
    shownAssetIds() {
      return this.selected ? [this.selected.id] : undefined;
    },
    mapFetchParams() {
      let params = {};
      if (this.filterAssetTypes && this.filterAssetTypes.length) params.codeIds = this.filterAssetTypes;
      return params;
    },
    orderId() {
      const order_order_id = _.get(this.order, 'id');
      const operation_order_id = _.get(this.operation, 'orderId');
      return order_order_id ? order_order_id : operation_order_id;
    },
    assetCodeChainIds() {
      let ids = [];
      if (this.localOrder) {
        ids.push(this.localOrder.order_type_id);
        ids.push(this.localOrder.order_subtype_id);
        ids.push(this.localOrder.problem_code_id);
      }
      if (this.operation) {
        ids.push(this.operation.activity_code_id);
        // Passing summary codes triggers "invalid with no asset selection" error 
        // ids.push(this.operation.repair_code_id);
        // ids.push(this.operation.failure_code_id);
        // ids.push(this.operation.outcome_code_id);
        // ids.push(this.operation.responsibility_code_id);
      }
      ids = _.filter(ids, Boolean);
      return ids;
    }
  },
  created() {
    // Clear saved assets
    this.$store.commit("AssetsMap/SET_ASSETS", []);

    this.mapConfig_ = {
      ...this.mapConfig_,
      ...this.mapConfig
    }

    if (this.disabled) {
      this.mapConfig_.scrollable = false;
      this.mapConfig_.clickable = false;
    }

    this.setMapCenter();
  },
  destroyed() {
    // Clear saved assets
    this.$store.commit("AssetsMap/SET_ASSETS", []);
  },
  watch: {
    selected: {
      handler(selected) {
        if (!selected) {
          this.$refs.assetsOfflineMap.unselectFeature();
        }
      }
    },
    height(height) {
      // search bar height
      this.mapConfig_.height = height - 50;
    },
    mode: {
      handler(mode) {
        this.mode_ = mode;
      },
      immediate: true
    },
    mode_(mode) {
      this.$emit("update:mode", mode);
    }
  },
  methods: {
    setMapCenter() {
      if (this.operation && !this.operation.asset) {
        if (this.order && this.order.loggedLat && this.order.loggedLng) {
          this.mapConfig_.center = {
            lat: this.order.loggedLat,
            lng: this.order.loggedLng
          };
        }
      }
    },
    onSelect(asset) {
      // if (asset.assetNodes.length) {
      //   let coordinateAddress = new google.maps.Geocoder();
      //   const latlng = {
      //     lat: parseFloat(asset.assetNodes[0].latitude),
      //     lng: parseFloat(asset.assetNodes[0].longitude),
      //   };
      //   coordinateAddress.geocode({'location': latlng}, (results, status) => {
      //     if (status === "OK") {
      //       if (results.length) {
      //         console.log(results[0]);
      //         this.$emit('coordinateAddress', coordinateAddress)
      //       }
      //     }
      //   });

      // }

      this.setLocation(null);
      this.$emit("update:selected", asset);
    },
    onAssetCreated(asset) {
      this.$refs.assetsOfflineMap.selectFeature(asset.id);
    },
    onClickMap(event) {
      this.$refs.assetsOfflineMap.unselectFeature();
      this.$emit('click-map', event);
    },
    onLocationFound(event) {
      this.$emit('locationfound', event);
    },
    setLocation(latlng = null, center = false) {
      if (this.mapConfig_.markerOnClick && this.$refs.assetsOfflineMap) {
        if (center) {
          this.$refs.assetsOfflineMap.$refs.leafletOfflineMap.resetView();
        }
        this.$refs.assetsOfflineMap.$refs.leafletOfflineMap.setMarkerOnClick(latlng);
        // Hack - no event is emitted on setMarkerOnClick
        this.$emit('locationfound', { latlng });
      }
    },

    // getAddressData(addressData) {

    //   this.searchAddress = addressData

    //   this.goToAddress()

    // },

    // goToAddress(){

    //   this.$refs.assetsOfflineMap.mapConfig_.center = {lat : this.searchAddress.latitude,lng: this.searchAddress.longitude};

    // },

    customFilterAssets(assets, extra) {
      // 2023-03-01 - Disabled
      return assets;
      let filtered = [];
      let config = _.isPlainObject(extra) ? extra : {};
      let assetCodes = _.get(config, 'assetCodes', []);
      let asset_code_ids = assetCodes.map(code => code.id);
      assets.forEach(a => {
        let code_id = a.code ? a.code.id : null;
        if (asset_code_ids.includes(code_id) || a.id == "created") {
          filtered.push(a);
        }
      });
      return filtered;
    },

    async requireOrder() {
      if (this.localOrder && this.localOrder.id) {
        return await Promise.resolve(this.localOrder);
      }
      // else if (this.order && this.order.id) {
      else if (this.order) {
        this.localOrder = this.order;
        return await Promise.resolve(this.order);
      }
      else {
        const vm = this;
        const order_id = this.orderId;
        return await new Promise((resolve, reject) => {
          OrderService.findOrderById(order_id).then(res => {
            const order = JsonDenormalizer.denormalize(res);
            vm.localOrder = order;
            resolve(order);
          })
          .catch(err => {
            reject(err);
          });
        });
      }
    }
  },
  mounted() {
    this.requireOrder();
    // this.$refs.addressAutoComplete.autocompleteText = this.address;
    // this.$nextTick(() => {
    //   this.$refs.addressAutoComplete.onChange()
    // })
  }
};
</script>

<style lang="scss">
.order-operations-modal-map {
  position: relative;

  .loading-overlay {
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderOperationsModalMap.vue